import React from 'react';
import PropTypes from 'prop-types';
import MetaCollectionFormAccordion from 'Components/UI/Meta/MetaForm/Components/MetaCollectionFormAccordion';
import { getFormattedDateWithTimezone } from 'Helpers/DateTime';
import { Box } from '@mui/material';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { useRightSidebarContext } from 'Views/Page/Content/RightSidebar/RightSidebarContext';
import Typography from 'Components/UI/Typography';
import { metaOverrideSet } from './metaOverrideSet';

const styles = (theme) => ({
  metaCollectionForm: {
    padding: theme.spacing(0, 0),
  },
  metaFormInline: {
    width: '100%',
    padding: theme.spacing(0),
  },
  titleText: {
    overflowWrap: 'anywhere',
  },
});

const AccordionList = ({
  classes,
}) => {
  const { rightSidebarCollection } = useRightSidebarContext();

  return (
    <MetaCollectionFormAccordion
      className={classes.metaCollectionForm}
      collection={rightSidebarCollection}
      metaOverrideSet={metaOverrideSet}
      titleGenerator={(resource) => {
        return (
          <Box>
            <Typography variant="h6" className={classes.titleText}>{resource.attr('sectionType')}</Typography>
            <Typography>{getFormattedDateWithTimezone(resource.attr('lastSaved'))}</Typography>
          </Box>
        );
      }}
      FormProps={{ readonly: true, className: classes.metaFormInline }}
      AccordionProps={{ square: true, elevation: 1 }}
    />
  );
};
AccordionList.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AccordionList);
